import { css, html, LitElement, TemplateResult } from "lit";
import { customElement, state } from "lit/decorators.js";
import { getAuthUser, isAuthConfigured, loginInstructor, whenAuthReady } from "./auth0.js";
import { backIcon } from "./icons.js";
import { navigate } from "./nav.js";
import { globalStyles } from "./styles.global.js";

@customElement("reading-bee-login")
export class ReadingBeeLogin extends LitElement {
  static override styles = [
    globalStyles,
    css`
      :host {
        display: block;
        min-height: 100%;
      }

      .page {
        min-height: 100dvh;
        display: grid;
        place-items: center;
        padding: 1.4rem 1.2rem calc(2rem + env(safe-area-inset-bottom));
      }

      .card {
        width: min(420px, 100%);
        display: grid;
        gap: 0.7rem;
        justify-items: start;
        padding: 1.15rem 1.15rem 1.25rem;
        border-radius: 22px;
        background: #1a1713;
        border: 1px solid var(--color-panel-border);
      }

      h1 {
        margin: 0;
        font-size: 1.25rem;
      }

      p {
        margin: 0;
      }

      .back {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        display: grid;
        place-items: center;
        color: var(--color-primary-text);
        background: #120f0c;
        border: 1px solid var(--color-panel-border);
      }
    `,
  ];

  @state() private unavailable = false;
  @state() private failed = false;

  override connectedCallback(): void {
    super.connectedCallback();
    void this.start();
  }

  override render(): TemplateResult {
    return html`
      <div class="page">
        <div class="card">
          <button class="back" aria-label="Back" @click=${this.home}>${backIcon}</button>
          <h1>Instructor sign-in</h1>
          ${
            this.unavailable
              ? html`
                  <p>Sign-in is not configured on this build.</p>
                `
              : this.failed
                ? html`
                    <p>Could not start sign-in. Try again from Settings.</p>
                  `
                : html`
                    <p>Taking you to sign in…</p>
                  `
          }
        </div>
      </div>
    `;
  }

  private start = async (): Promise<void> => {
    await whenAuthReady();
    if (!isAuthConfigured()) {
      this.unavailable = true;
      return;
    }
    if (getAuthUser()) {
      this.homeSignedIn();
      return;
    }
    try {
      await loginInstructor("/");
    } catch {
      this.failed = true;
    }
  };

  private homeSignedIn = (): void => {
    navigate("reading");
  };

  private home = (): void => {
    navigate("reading");
  };
}

declare global {
  interface HTMLElementTagNameMap {
    "reading-bee-login": ReadingBeeLogin;
  }
}
